
import { IPlatform } from "../services";
import { Encryptor, LzEncryptor } from "./Encryptor";

export const CacheManager = {

    PROFILE_KEY: "rivtn.p",
    ACTIVE_PLATFORM: "rivtn.ap",
    __cacheImpl__: localStorage,
    ACCESS_TOKEN_KEY: "rivtn.at",
    SESSION_TOKEN_KEY: "rivtn.st",
    __encryptorImpl__: LzEncryptor,

    setStorage(cacheImpl: Storage) {
        CacheManager.__cacheImpl__ = cacheImpl;
    },

    setEncryptor(encryptorImpl: Encryptor) {
        CacheManager.__encryptorImpl__ = encryptorImpl;
    },

    has(key: string, __cacheImpl__?: any) {
        const item = (__cacheImpl__ ?? CacheManager.__cacheImpl__).getItem(key);
        return (item !== null && item !== "")
    },

    remove(key: string) {
        CacheManager.__cacheImpl__.removeItem(key);
    },

    insecurePut(key: string, value: string | number | Object, __cacheImpl__?: any) {
        const valueToStore = JSON.stringify({
            value,
            type: typeof value,
        });
        (__cacheImpl__ ?? CacheManager.__cacheImpl__).setItem(key, CacheManager.__encryptorImpl__ ? CacheManager.__encryptorImpl__.encrypt(valueToStore) : valueToStore);
    },

    put(key: string, value: string | number | Object) {
        if (!CacheManager.has(CacheManager.ACCESS_TOKEN_KEY)) return;
        CacheManager.insecurePut(key, value);
    },

    get(key: string, fallback?: any, __cacheImpl__?: any) {
        if (!CacheManager.has(key, __cacheImpl__)) {
            return fallback;
        }
        const cacheValue = (__cacheImpl__ ?? CacheManager.__cacheImpl__).getItem(key) as string;
        const valueToStore = JSON.parse(CacheManager.__encryptorImpl__ ? CacheManager.__encryptorImpl__.decrypt(cacheValue) : cacheValue);
        return valueToStore.value;
    },

    getPlatform(platform?: string) {
        if (!platform) {
            window.location.replace("/");
            return;
        }
        const cachedPlatform = CacheManager.get(CacheManager.ACTIVE_PLATFORM, undefined, sessionStorage) as IPlatform;
        return ((platform === cachedPlatform?.slug || platform === cachedPlatform?.external_id) ? cachedPlatform : undefined);
    },

    clear() {
        CacheManager.__cacheImpl__.clear();
    }

}
